import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  TextField, Button, Box, Typography, Paper, Grid, Checkbox, FormControlLabel, MenuItem
} from '@mui/material';
import { ApiRequest } from '../../services/api';

const EditIngredient = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [marcas, setMarcas] = useState([]);
  const [ingredient, setIngredient] = useState(null);
  const [imagePreview, setImagePreview] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await ApiRequest(`api/Ingrediente/ObtenerPorId/${id}`, 'GET');
        setIngredient(data);
        setImagePreview(data.imagen ? `data:image/jpeg;base64,${data.imagen}` : '');

        const marcasResponse = await ApiRequest("api/Catalogo/ListarMarcas", "GET");
        setMarcas(marcasResponse);
      } catch (error) {
        console.error("Error cargando ingrediente o marcas:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1];
      setIngredient(prev => ({ ...prev, imagen: base64 }));
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    try {
      await ApiRequest(`api/Ingrediente/${id}`, 'PUT', ingredient);
      navigate('/Dashboard/Ingredientes');
    } catch (error) {
      console.error("Error guardando ingrediente:", error);
    }
  };

  if (!ingredient) return <div>Cargando...</div>;

  return (
    <Paper sx={{ padding: 3, maxWidth: 500, margin: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Editar Ingrediente
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Nombre"
            fullWidth
            value={ingredient.nombre}
            onChange={(e) => setIngredient({ ...ingredient, nombre: e.target.value })}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ingredient.esProducto}
                onChange={(e) => setIngredient({ ...ingredient, esProducto: e.target.checked })}
              />
            }
            label="¿Es un producto?"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label="Marca (opcional)"
            fullWidth
            value={ingredient.marca || ''}
            onChange={(e) => {
              setIngredient({ ...ingredient, marca: e.target.value }); // Guarda el nombre (texto)
            }}
          >
            <MenuItem value="">Sin marca</MenuItem>
            {marcas.map((marca) => (
              <MenuItem key={marca.id} value={marca.nombre}>
                {marca.nombre}
              </MenuItem>
            ))}
          </TextField>

        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" component="label" fullWidth>
            Cambiar Imagen
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
          </Button>
        </Grid>
        {imagePreview && (
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <img
              src={imagePreview}
              alt="Vista previa"
              style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8 }}
            />
            <Button
              variant="outlined"
              color="secondary"
              sx={{ mt: 1 }}
              onClick={() => {
                setIngredient(prev => ({ ...prev, imagen: '' }));
                setImagePreview('');
              }}
            >
              Eliminar Imagen
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Button variant="contained" fullWidth onClick={handleSave}>
            Guardar Cambios
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditIngredient;
